// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-info .card, .client-summary .card {
  position: relative;
  font-size: 20px;
}

.client-info .card {
  min-height: 97%;
}
.client-info .card h1 {
  font-size: 48px;
  border-bottom: none;
  margin-bottom: 5px !important;
}

.default-btn {
  font-size: 20px !important;
  width: 100%;
  padding: 5px !important;
}

h2.trust {
  color: white;
  background: green;
  padding: 1px 10px;
  width: -webkit-min-content;
  width: min-content;
  white-space: nowrap;
  position: absolute;
  top: 10px;
  right: 10px;
  font-weight: 700;
}

.center-text {
  text-align: center;
}

.drag-drop {
  background: #e5e5e5;
  margin-bottom: 10px;
  padding: 40px 0px;
  vertical-align: middle;
  width: 100%;
}

.aligner {
  display: flex;
  align-items: center;
  justify-content: center;
  color: grey;
}

.client-summary .card  h2 {
  font-size: 30px;
}

.info-buttons {
  position: absolute;
  bottom: 1em;
  left: 10px;
  width: 100%;
}

.relative {
  position: relative;
}

.deposit-info h1 {
  display: inline-block;
  border:none !important;
  margin: 0 !important;
  font-size: 30px;
  font-weight: 700
}

.deposit-header {
  border-bottom: 1px solid #e5e5e5;
  margin: 0 0 1em 0 !important;
}

.deposit-header button {
  display: inline-block;
  width: -webkit-min-content;
  width: min-content;
  white-space: nowrap;
  padding: 5px 25px !important;
  min-width: 175px;
  float: right;
}
.top-right {
  position: absolute !important;
  right: 1em;
  top: .7em;
  width: -webkit-min-content;
  width: min-content;
  white-space: nowrap;
  padding: 5px 25px !important;
  min-width: 175px;
}

.card.relative h1 {
  border-bottom: none;
  font-size: 30px;
  font-weight: 700;
}

.note-button {
  position: fixed;
  bottom: 1em;
  right: 1em;
  background: #10497F;
  color: white;
  padding: .5em;
  border-radius: 50%;
  font-size: 30px;
  border: none;
}
.note-button:hover {
  background-color: #2c659a;
  cursor: pointer;
}
.note-button:focus {
  outline:none;
}

.tranaction-button {
  position: fixed;
  bottom: 0px;
  right: 6em;
  background: #5CB85C;
  color: white;
  padding: 1em;
  padding-bottom: 10px;
  padding-top: .5em;
  border-radius: 10px 10px 0px 0px;
  font-size: 20px;
  border: none;
}
.tranaction-button:hover {
  background: #3c9a3c;
  cursor: pointer;
}
.tranaction-button:focus {
  outline:none; 
}
i.pi.pi-check-circle.green {
  color: green;
  top: 6px;
  position: relative;
  padding-right: 5px;
}

i.pi.pi-times-circle {
  color: red;
  top: 6px;
  position: relative;
  padding-right: 5px
}

#all-documents button.p-button.p-button-warning.default-btn {
  position: absolute;
  bottom: 10px;
  width: 260px;
  left: calc(50% - 130px)
}

.new-note {
  width: 500px;
  max-width: 500px !important;
  height: 400px;
}

.new-note textarea { 
  min-height: 110px;
}`, "",{"version":3,"sources":["webpack://./src/views/Client/client.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,0BAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf;AACF;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,0BAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,UAAU;EACV,SAAS;EACT,0BAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".client-info .card, .client-summary .card {\n  position: relative;\n  font-size: 20px;\n}\n\n.client-info .card {\n  min-height: 97%;\n}\n.client-info .card h1 {\n  font-size: 48px;\n  border-bottom: none;\n  margin-bottom: 5px !important;\n}\n\n.default-btn {\n  font-size: 20px !important;\n  width: 100%;\n  padding: 5px !important;\n}\n\nh2.trust {\n  color: white;\n  background: green;\n  padding: 1px 10px;\n  width: min-content;\n  white-space: nowrap;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-weight: 700;\n}\n\n.center-text {\n  text-align: center;\n}\n\n.drag-drop {\n  background: #e5e5e5;\n  margin-bottom: 10px;\n  padding: 40px 0px;\n  vertical-align: middle;\n  width: 100%;\n}\n\n.aligner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: grey;\n}\n\n.client-summary .card  h2 {\n  font-size: 30px;\n}\n\n.info-buttons {\n  position: absolute;\n  bottom: 1em;\n  left: 10px;\n  width: 100%;\n}\n\n.relative {\n  position: relative;\n}\n\n.deposit-info h1 {\n  display: inline-block;\n  border:none !important;\n  margin: 0 !important;\n  font-size: 30px;\n  font-weight: 700\n}\n\n.deposit-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: 0 0 1em 0 !important;\n}\n\n.deposit-header button {\n  display: inline-block;\n  width: min-content;\n  white-space: nowrap;\n  padding: 5px 25px !important;\n  min-width: 175px;\n  float: right;\n}\n.top-right {\n  position: absolute !important;\n  right: 1em;\n  top: .7em;\n  width: min-content;\n  white-space: nowrap;\n  padding: 5px 25px !important;\n  min-width: 175px;\n}\n\n.card.relative h1 {\n  border-bottom: none;\n  font-size: 30px;\n  font-weight: 700;\n}\n\n.note-button {\n  position: fixed;\n  bottom: 1em;\n  right: 1em;\n  background: #10497F;\n  color: white;\n  padding: .5em;\n  border-radius: 50%;\n  font-size: 30px;\n  border: none;\n}\n.note-button:hover {\n  background-color: #2c659a;\n  cursor: pointer;\n}\n.note-button:focus {\n  outline:none;\n}\n\n.tranaction-button {\n  position: fixed;\n  bottom: 0px;\n  right: 6em;\n  background: #5CB85C;\n  color: white;\n  padding: 1em;\n  padding-bottom: 10px;\n  padding-top: .5em;\n  border-radius: 10px 10px 0px 0px;\n  font-size: 20px;\n  border: none;\n}\n.tranaction-button:hover {\n  background: #3c9a3c;\n  cursor: pointer;\n}\n.tranaction-button:focus {\n  outline:none; \n}\ni.pi.pi-check-circle.green {\n  color: green;\n  top: 6px;\n  position: relative;\n  padding-right: 5px;\n}\n\ni.pi.pi-times-circle {\n  color: red;\n  top: 6px;\n  position: relative;\n  padding-right: 5px\n}\n\n#all-documents button.p-button.p-button-warning.default-btn {\n  position: absolute;\n  bottom: 10px;\n  width: 260px;\n  left: calc(50% - 130px)\n}\n\n.new-note {\n  width: 500px;\n  max-width: 500px !important;\n  height: 400px;\n}\n\n.new-note textarea { \n  min-height: 110px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
